import { Stack, Tooltip } from '@mui/material';
import { IconButton } from '@retail/products/components';
import { ActivateIcon, DeactivateIcon, EditButtonIcon, TrashIcon } from '@shared/custom-icons';
import { useCalculusTranslation } from '@retail/calculus/i18n';

interface Props {
  handleActivate?: () => void;
  handleDeactivate?: () => void;
  handleEdit?: () => void;
  handleDelete?: () => void;
}

export const ConditionsTableActions = ({
  handleActivate,
  handleDeactivate,
  handleEdit,
  handleDelete,
}: Props) => {
  const { t } = useCalculusTranslation();
  return (
    <Stack flexDirection="row" alignItems="center">
      {handleActivate && (
        <Tooltip title={t('calculus.actions.activateOnThisLevel')}>
          <IconButton onClick={handleActivate}>
            <ActivateIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {handleEdit && (
        <Tooltip title={t('calculus.actions.editCondition')}>
          <IconButton onClick={handleEdit} aria-label={t('calculus.edit')}>
            <EditButtonIcon fontSize="medium" />
          </IconButton>
        </Tooltip>
      )}
      {handleDeactivate && (
        <Tooltip title={t('calculus.actions.deactivate')}>
          <IconButton onClick={handleDeactivate} aria-label={t('calculus.deactivate')}>
            <DeactivateIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {handleDelete && (
        <Tooltip title={t('calculus.actions.deleteFromDraft')}>
          <IconButton onClick={handleDelete}>
            <TrashIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
};
